import { useQuery, UseQueryOptions } from 'react-query';
import axiosInstance from '../../helpers/axiosInstance';
import { QueryKeys } from '../QueryKeys';

export const useUserExperience = (extraOptions: UseQueryOptions<UserExperience> = {}) => {
  return useQuery<UserExperience>(
    QueryKeys.userExperience(),
    async () => {
      return axiosInstance
        .get<{ experience: UserExperience }>('/patients/experience', {
          params: {},
        })
        .then((r) => r.data.experience);
    },
    extraOptions,
  );
};

export enum NavBarMenu {
  Home = 'Home',
  Appointments = 'Appointments',
  Plans = 'Plans',
  Community = 'Community',
  Chat = 'Chat',
}

export enum UserExperienceMemberState {
  Onboarding = 'onboarding',
  Intake = 'intake',
  Followup = 'followup',
}

export enum UserExperiencePlanType {
  NP = 'NP',
  IOP = 'IOP',
  CORE = 'CC',
}

export type UserExperienceMember = {
  id: string;
  state: UserExperienceMemberState;
  plans: UserExperiencePlanType[];
  consultId: string | null;
  unfinishedNpOnboarding?: boolean;
  unfinishedCoreOnboarding?: boolean;
};

export type UserExperience = {
  name: string;
  landingPage: string;
  homePage: string;
  menus: NavBarMenu[];
  members: UserExperienceMember[];
  firstLoginAt: string | null;
};
